import axios from 'axios';
import BaseApi from './base';
import {
    GET_ATTESTATIONS,
    GET_ATTESTATION_BY_ID,
    SAVE_ATTESTATION_TEST,
    GET_ATTESTATION_BLOCK,
    GET_ATTESTATION_TEST_BY_ID
} from '../constants/api';

export default class extends BaseApi {
    static getAttestation() {
        return axios.get(GET_ATTESTATIONS);
    }
    static getAttestationById(id) {
        return axios.get(`${GET_ATTESTATION_BY_ID}/${id}`);
    }
    static getAttestationTestById(id) {
        return axios.get(`${GET_ATTESTATION_TEST_BY_ID}/${id}`);
    }
    static saveAttestationTest(data) {
        return axios.post(SAVE_ATTESTATION_TEST, data);
    }
    static getAttestationBlock(data) {
        return axios.post(GET_ATTESTATION_BLOCK, data);
    }
}
